import { useQuery } from '@tanstack/react-query'
import { customFieldColors, OpalApiRequestParams } from '@opallabs/api/v3'
import { useWorkspace } from '@opallabs/hooks'
import { globalQueryKeys } from '../../queryKeys'
import { selectCustomFieldColors } from './selectors'
import {
  CustomFieldColorsSelectedResponseData,
  RawCustomFieldColorsResponse,
} from './types'

type UseGetCustomFieldColorsOptions = {
  enabled?: boolean
  select?: (
    data: RawCustomFieldColorsResponse
  ) => CustomFieldColorsSelectedResponseData[]
  params?: OpalApiRequestParams<'ReadCustomFieldColorsV3'>
}

const getCustomFieldColorsQuery = (
  params?: OpalApiRequestParams<'ReadCustomFieldColorsV3'>
) => ({
  queryKey: globalQueryKeys.customFieldColors(params),
  queryFn: () => customFieldColors.readCollection({ params }),
})

export const useGetCustomFieldColors = ({
  enabled,
  select = selectCustomFieldColors,
  params,
}: UseGetCustomFieldColorsOptions) => {
  const { uuid: workspaceUuid } = useWorkspace()

  return useQuery({
    ...getCustomFieldColorsQuery({
      query: {
        filter: {
          workspace_id: [workspaceUuid],
        },
      },
      ...params,
    }),
    enabled,
    select,
  })
}
